export default "__VITE_ASSET__BuAsYYH6__"